<template>
  <VueModal modal-class="modal modal-lg"  title="Edit Profile: We are here to reimagine..." v-model="modalOpen">
    <div>
      <div class="mb-12">
        <label for="reimagine" ref="reimagine">
          Finish the following: "What I'm / What we're here to reimagine..."
          <span class="text-sm font-sans-book block">
            240 characters maximum. What is your inspiring vision, mantra, or change you wish to see in the world? Keep this short, sweet, and unique.
          </span>
        </label>

        <textarea
          id="reimagine"
          name="reimagine"
          v-model="form.reimagine"
          v-validate="'max:240'"
          class="w-full mt-3 p-4 overflow-y-scroll border border-black h-48 bg-transparent"
        />

        <div class="text-sm font-sans-italic text-gray-dark mt-1">
          Character count: {{ form.reimagine ? form.reimagine.length : 0 }}
        </div>

        <span v-show="errors.has('reimagine')" class="error text-error-red text-lg">
          {{ errors.first('reimagine') }}
        </span>
      </div>
      <div class="flex justify-center">
        <button type="button" class="button" @click="update">
          Update
        </button>
      </div>
    </div>
  </VueModal>
</template>

<script>
import VueModal from '@kouts/vue-modal'
import {mapGetters} from "vuex";
import {organizationAPI} from "../../../../../api/organizationAPI";

export default {
  name: "OrganizationReimagineModal",
  props: {
    value: { type: Boolean, required: true }
  },
  components: { VueModal },
  computed: {
    ...mapGetters({ organization: "organization" }),
    modalOpen: {
      get() {
        return this.value;
      },
      set(localModalIsSet) {
        this.$emit('input', localModalIsSet);
      }
    }
  },
  watch: {
    organization() {
      this.setForm();
    }
  },
  data() {
    return {
      form: {
        reimagine: ''
      },
      loading: false,
    }
  },
  methods: {
    setForm() {
      this.form.reimagine = this.organization.reimagine;
    },
    async update() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      await organizationAPI.updateProfileReimagine(this.form);
      await this.$store.dispatch('getMe');
      await this.$store.dispatch('getOrganization', { id: this.organization.id });
      this.loading = false;
      this.modalOpen = false;
    }
  },
  mounted() {
    this.setForm();
  }
}
</script>

<style scoped>

</style>